module.exports = __webpack_public_path__ + "static/media/postman.f37754eb.svg";